import store from 'Src/store';

const getStoredApplication = () => {
  const state = store.getState();
  return state?.application ?? {};
};

export default getStoredApplication;
